import React, { ReactElement } from "react"
import { styled, alpha, darken } from '@mui/material/styles'
import { ChipProps, Chip } from "@mui/material"
import chroma from "chroma-js"
import {
  Autorenew as PendingApprovalIcon,
  Edit as DraftIcon,
  Error as ErrorIcon,
  Check as TickIcon,
  Cancel as StoppedIcon,
  ReportProblem as WarningIcon,
  Star as StarIcon,
  HourglassEmpty as PendingIcon,
  PlayArrow as RunningIcon,
  Check as CheckIcon,
  PlayArrowOutlined as PlayIcon,
  Pause as PausedIcon,
  AccessTime as ScheduledIcon,
  Inventory as ArchivedIcon,
  NotInterested as InactiveIcon,
  CallMerge as ConflictIcon
} from "@mui/icons-material"

export const ChipGrey = styled(Chip)<ChipProps>(({ theme }) => {
  return {
      "&.MuiChip-root": {
          background: theme.colorScales.light(0).css(),
          border: "none",
          outline: `1px solid ${alpha(darken(theme.basePalette.border, 0.1), 0.2)}`,
          outlineOffset: -1
      },
      "& .MuiChip-label": {
          color: theme.palette.text.primary
      },
      "& .MuiSvgIcon-root": {
        fill: alpha(theme.palette.text.primary, 0.5),
        width: 16,
        height: 16,
        marginLeft: 8
      }
  }
})

export const ChipGreyLight = styled(Chip)<ChipProps>(({ theme }) => {
  return {
    "&.MuiChip-root": {
      background: theme.colorScales.light(.8).css(),
      border: "none",
      outline: `1px solid ${alpha(darken(theme.basePalette.border, 0.1), 0.2)}`,
      outlineOffset: -1
    },
    "& .MuiChip-label": {
        color: theme.palette.text.primary
    },
    "& .MuiSvgIcon-root": {
      fill: alpha(theme.palette.text.primary, 0.5),
      width: 16,
      height: 16,
      marginLeft: 8
    }
  }
})

export const ChipGreen = styled(Chip)<ChipProps>(({ theme }) => {
  return {
      "&.MuiChip-root": {
          background: alpha(theme.palette.success.light, 0.6),
          border: "none",
          outline: `1px solid ${alpha(darken(theme.basePalette.border, 0.1), 0.2)}`,
          outlineOffset: -1
      },
      "& .MuiChip-label": {
          color: theme.palette.text.primary
      },
      "& .MuiSvgIcon-root": {
        fill: theme.palette.success.dark,
        width: 16,
        height: 16,
        marginLeft: 8
      }
  }
})

export const ChipGreenLight = styled(Chip)<ChipProps>(({ theme }) => {
  return {
      "&.MuiChip-root": {
          background: alpha(theme.palette.success.light, 0.2),
          border: "none",
          outline: `1px solid ${alpha(darken(theme.basePalette.border, 0.1), 0.2)}`,
          outlineOffset: -1
      },
      "& .MuiChip-label": {
          color: theme.palette.text.primary
      },
      "& .MuiSvgIcon-root": {
        fill: theme.palette.success.dark,
        width: 16,
        height: 16,
        marginLeft: 8
      }
  }
})


export const ChipRed = styled(Chip)<ChipProps>(({ theme }) => {
  return {
      "&.MuiChip-root": {
          background: alpha(theme.palette.error.light, 0.6),
          border: "none",
          outline: `1px solid ${alpha(darken(theme.basePalette.border, 0.1), 0.2)}`,
          outlineOffset: -1
      },
      "& .MuiChip-label": {
          color: theme.palette.text.primary
      },
      "& .MuiSvgIcon-root": {
        fill: theme.palette.error.dark,
        width: 16,
        height: 16,
        marginLeft: 8
      }
  }
})

export const ChipRedLight = styled(Chip)<ChipProps>(({ theme }) => {
  return {
      "&.MuiChip-root": {
          background: alpha(theme.palette.error.light, 0.2),
          border: "none",
          outline: `1px solid ${alpha(darken(theme.basePalette.border, 0.1), 0.2)}`,
          outlineOffset: -1
      },
      "& .MuiChip-label": {
          color: theme.palette.text.primary
      },
      "& .MuiSvgIcon-root": {
        fill: theme.palette.error.dark,
        width: 16,
        height: 16,
        marginLeft: 8
      }
  }
})

export const ChipBlue = styled(Chip)<ChipProps>(({ theme }) => {
  return {
      "&.MuiChip-root": {
          background: theme.colorScales.blues(1).css(),
          border: "none",
          outline: `1px solid ${alpha(darken(theme.basePalette.border, 0.1), 0.2)}`,
          outlineOffset: -1
      },
      "& .MuiChip-label": {
          color: theme.palette.text.primary
      },
      "& .MuiSvgIcon-root": {
        fill: theme.colorScales.blues(0).css(),
        width: 16,
        height: 16,
        marginLeft: 8
      }
  }
})

export const ChipBlueLight = styled(Chip)<ChipProps>(({ theme }) => {
  return {
    "&.MuiChip-root": {
      background: theme.colorScales.blues(1).alpha(0.5).css(),
      border: "none",
      outline: `1px solid ${alpha(darken(theme.basePalette.border, 0.1), 0.2)}`,
      outlineOffset: -1
    },
    "& .MuiChip-label": {
        color: theme.palette.text.primary
    },
    "& .MuiSvgIcon-root": {
      fill: theme.colorScales.blues(0).css(),
      width: 16,
      height: 16,
      marginLeft: 8
    }
  }
})

export const ChipAmber = styled(Chip)<ChipProps>(({ theme }) => {
  return {
      "&.MuiChip-root": {
          background: alpha(theme.palette.warning.light, 0.6),
          border: "none",
          outline: `1px solid ${alpha(darken(theme.basePalette.border, 0.1), 0.2)}`,
          outlineOffset: -1
      },
      "& .MuiChip-label": {
          color: theme.palette.text.primary
      },
      "& .MuiSvgIcon-root": {
        fill: theme.palette.warning.dark,
        width: 16,
        height: 16,
        marginLeft: 8
      }
  }
})

export const ChipAmberLight = styled(Chip)<ChipProps>(({ theme }) => {
  return {
      "&.MuiChip-root": {
          background: alpha(theme.palette.warning.light, 0.2),
          border: "none",
          outline: `1px solid ${alpha(darken(theme.basePalette.border, 0.1), 0.2)}`,
          outlineOffset: -1
      },
      "& .MuiChip-label": {
          color: theme.palette.text.primary
      },
      "& .MuiSvgIcon-root": {
        fill: theme.palette.warning.dark,
        width: 16,
        height: 16,
        marginLeft: 8
      }
  }
})


export const ChipLive = (props: ChipProps) => {

  const extraProps: ChipProps = {}
  if (!props.label) {
    extraProps.label = "Live"
  }

  return (
    <ChipGreen {...props} icon={<PlayIcon />} {...extraProps}>
      {props.children}
    </ChipGreen>
  )
}

export const ChipScheduled = (props: ChipProps) => {

  const extraProps: ChipProps = {}
  if (!props.label) {
    extraProps.label = "Scheduled"
  }

  return (
    <ChipGreenLight {...props} icon={<ScheduledIcon />} {...extraProps}>
      {props.children}
    </ChipGreenLight>
  )
}

export const ChipReady = (props: ChipProps) => {

  const extraProps: ChipProps = {}
  if (!props.label) {
    extraProps.label = "Ready"
  }

  return (
    <ChipGreenLight {...props} icon={<PlayIcon />} {...extraProps}>
      {props.children}
    </ChipGreenLight>
  )
}

export const ChipDraft = (props: ChipProps) => {

  const extraProps: ChipProps = {}
  if (!props.label) {
    extraProps.label = "Draft"
  }

  return (
    <ChipBlueLight {...props} icon={<DraftIcon />} {...extraProps}>
      {props.children}
    </ChipBlueLight>
  )
}

export const ChipPaused = (props: ChipProps) => {

  const extraProps: ChipProps = {}
  if (!props.label) {
    extraProps.label = "Paused"
  }

  return (
    <ChipBlueLight {...props} icon={<PausedIcon />} {...extraProps}>
      {props.children}
    </ChipBlueLight>
  )
}


export const ChipWarning = (props: ChipProps) => {

  const extraProps: ChipProps = {}
  if (!props.label) {
    extraProps.label = "Warning"
  }

  return (
    <ChipAmber {...props} icon={<WarningIcon />} {...extraProps}>
      {props.children}
    </ChipAmber>
  )
}

export const ChipConflict = (props: ChipProps) => {

  const extraProps: ChipProps = {}
  if (!props.label) {
    extraProps.label = "Conflict"
  }

  return (
    <ChipAmber {...props} icon={<ConflictIcon />} {...extraProps}>
      {props.children}
    </ChipAmber>
  )
}

export const ChipInactive = (props: ChipProps) => {

  const extraProps: ChipProps = {}
  if (!props.label) {
    extraProps.label = "Inactive"
  }

  return (
    <ChipGreyLight {...props} icon={<InactiveIcon />} {...extraProps}>
      {props.children}
    </ChipGreyLight>
  )
}

export const ChipArchived = (props: ChipProps) => {

  const extraProps: ChipProps = {}
  if (!props.label) {
    extraProps.label = "Archived"
  }

  return (
    <ChipGrey {...props} icon={<ArchivedIcon />} {...extraProps}>
      {props.children}
    </ChipGrey>
  )
}



export const ChipError = (props: ChipProps) => {

  const extraProps: ChipProps = {}
  if (!props.label) {
    extraProps.label = "Error"
  }

  return (
    <ChipRed {...props} icon={<ErrorIcon />} {...extraProps}>
      {props.children}
    </ChipRed>
  )
}

export const ChipFailed = (props: ChipProps) => {

  const extraProps: ChipProps = {}
  if (!props.label) {
    extraProps.label = "Failed"
  }

  return (
    <ChipRed {...props} icon={<ErrorIcon />} {...extraProps}>
      {props.children}
    </ChipRed>
  )
}
